import { render, staticRenderFns } from "./DecorPreview.vue?vue&type=template&id=08961c69&"
import script from "./DecorPreview.vue?vue&type=script&lang=js&"
export * from "./DecorPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports